export const RESET_PASSWORD_SET_VALUE = 'RESET_PASSWORD_SET_VALUE';
export const RESET_PASSWORD_IS_LOADING = 'RESET_PASSWORD_IS_LOADING';
